import { atom, useRecoilState } from 'recoil';
import type { IPresencePrompt } from './inactivityStorage';

// Mirrors localStorage.presencePrompt so the modal re-renders; storage stays the cross-tab source of truth.
export const aPresencePrompt = atom<IPresencePrompt | null>({ key: 'aPresencePrompt', default: null });

export const usePresencePrompt = (): [IPresencePrompt | null, (prompt: IPresencePrompt | null) => void] => {
    return useRecoilState(aPresencePrompt);
};
